import React, { Fragment } from 'react'

import Script from 'dangerous-html/react'
import { Helmet } from 'react-helmet'

import Navigation from '../components/navigation'
import Footer from '../components/footer'
import './terms-of-service.css'

const TermsOfService = (props) => {
  return (
    <div className="terms-of-service-container1">
      <Helmet>
        <title>TermsOfService - California Places</title>
        <meta
          property="og:title"
          content="TermsOfService - California Places"
        />
        <link
          rel="canonical"
          href="https://copy-of-glass-outstanding-chamois-m7jub6.teleporthq.app/terms-of-service"
        />
        <meta
          property="og:url"
          content="https://copy-of-glass-outstanding-chamois-m7jub6.teleporthq.app/terms-of-service"
        />
      </Helmet>
      <Navigation
        button={
          <Fragment>
            <span className="terms-of-service-text1">Contact Us</span>
          </Fragment>
        }
        button1={
          <Fragment>
            <span className="terms-of-service-text2">Pricing</span>
          </Fragment>
        }
        rootClassName="navigationroot-class-name2"
      ></Navigation>
      <div className="terms-of-service-container2">
        <div className="terms-of-service-container3">
          <Script
            html={`<div
  style="font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif; padding: 2em; max-width: 800px; margin: 0 auto; color: #222; line-height: 1.6;">

  <h1 style="text-align: center;">California Places — Terms of Service</h1>
  <p style="text-align: center;"><strong>Last Updated: April 25, 2026</strong></p>

  <p>Please read these Terms of Service ("Terms") carefully before using the California Places mobile application
    ("App") operated by California Places L.L.C. ("Company," "we," "us," or "our"). By downloading, accessing, or using
    the App, you agree to be bound by these Terms. If you do not agree, do not use
    the App.</p>

  <hr>

  <h2>1. Nature of the Service</h2>

  <p>California Places is an informational tool that aggregates, combines, and displays data related to California real
    estate parcels, including but not limited to: assessor parcel data, zoning, environmental hazards, flood zones,
    fault lines, fire hazard severity, air quality, soil conditions, noise
    levels, code enforcement activity, building permits, school districts, utility providers, law enforcement
    jurisdictions, government representatives, census demographics, and other property-related information.</p>

  <p>
    <strong>THE APP IS AN INFORMATIONAL REFERENCE TOOL ONLY. IT IS NOT A PROFESSIONAL SERVICE AND DOES NOT PROVIDE REAL ESTATE ADVICE, LEGAL ADVICE, ENVIRONMENTAL CONSULTING, PROPERTY INSPECTION, TITLE SEARCH, APPRAISAL, OR ANY OTHER PROFESSIONAL SERVICE.</strong>
  </p>

  <hr>

  <h2>2. Data Sources, Inferences, and Accuracy</h2>

  <h3>2.1 Third-Party Data Sources</h3>

  <p>The data presented in the App is sourced from publicly available government records and third-party data providers,
    including but not limited to: county assessor offices, the California Department of Education, the U.S.
    Environmental Protection Agency, CalFire, FEMA, the U.S. Census Bureau, the
    California Department of Conservation, local code enforcement agencies, local building permit systems, and various
    federal, state, and local government databases.</p>

  <p>We are not the authoritative source for any data displayed in the App. Data is obtained from government agencies
    and third-party providers who themselves may or may not be the authoritative source for such data, and who may in
    turn rely on other sources, self-reported information, or estimates. Many of
    these agencies and providers themselves disclaim the accuracy, completeness, and timeliness of their own data, and
    such data is often provided subject to their own terms of use and disclaimers. Our presentation of this data does
    not imply any degree of accuracy or reliability. In fact, due to our
    aggregation, combination, and transformation of data from multiple sources, the information we present may be
    significantly less accurate and reliable than the original sources from which it was derived.</p>

  <h3>2.2 Data Combination and Inferences</h3>

  <p>The App combines data from multiple sources and may generate inferences, calculations, derived metrics,
    visualizations, categorizations, severity assessments, proximity determinations, and other conclusions based on that
    data. <strong>These methods, combinations, and conclusions may be entirely         
  incorrect.</strong> We may make no effort whatsoever to verify the accuracy, completeness, or correctness of any
    derived or inferred information presented in the App.</p>

  <h3>2.3 No Guarantee of Accuracy</h3>

  <p>ALL DATA, MAPS, IMAGES, CALCULATIONS, INFERENCES, AND OTHER INFORMATION PRESENTED IN THE APP ARE PROVIDED ON AN "AS
    IS" AND "AS AVAILABLE" BASIS. WE MAKE NO REPRESENTATIONS OR WARRANTIES OF ANY KIND, EXPRESS OR IMPLIED, REGARDING
    THE ACCURACY, COMPLETENESS, TIMELINESS, RELIABILITY, OR SUITABILITY OF ANY
    INFORMATION DISPLAYED.</p>

  <p>Data may be incomplete, outdated, delayed, erroneous, or otherwise inaccurate. Property boundaries, parcel numbers,
    zoning designations, hazard zones, code enforcement records, permit statuses, environmental conditions, and all
    other information may not reflect current or actual conditions.</p>

  <h3>2.4 Not a Substitute for Professional Services</h3>

  <p>The App is not a substitute for any of the following, and you should not rely on the App in place of:</p>

  <ul>
    <li>A professional property inspection</li>
    <li>A title search or title insurance</li>
    <li>A real estate appraisal</li>
    <li>Environmental site assessment (Phase I or Phase II)</li>
    <li>Legal advice or legal review</li>
    <li>A professional land survey</li>
    <li>Engineering or geological assessment</li>
    <li>Any other professional evaluation relevant to real property</li>
  </ul>

  <hr>

  <h2>3. User Responsibility</h2>

  <h3>3.1 Assumption of Risk</h3>

  <p>YOU ASSUME FULL AND COMPLETE RESPONSIBILITY FOR ANY AND ALL DECISIONS YOU MAKE, ACTIONS YOU TAKE, OR CONCLUSIONS
    YOU DRAW BASED ON INFORMATION OBTAINED THROUGH THE APP. You agree to independently verify all information presented
    in the App before making any decision, including but not limited to
    decisions relating to the purchase, sale, lease, development, improvement, or use of real property.</p>

  <h3>3.2 No Reliance</h3>

  <p>You acknowledge and agree that you will not rely solely on the information provided by the App for any purpose. Any
    reliance you place on such information is strictly at your own risk.</p>

  <hr>

  <h2>4. Subscriptions and Payments</h2>

  <h3>4.1 In-App Subscriptions</h3>

  <p>Access to certain features of the App requires a paid subscription, processed through Apple's App Store or Google
    Play Store via RevenueCat. Subscription terms, pricing, and billing cycles are presented at the time of purchase.
  </p>

  <h3>4.2 Automatic Renewal</h3>

  <p>Subscriptions automatically renew at the end of each billing period unless canceled at least 24 hours before the
    end of the current period. You may manage and cancel your subscription through your device's App Store or Play Store
    account settings. In accordance with California Business and Professions
    Code sections 17600-17606, by subscribing you provide affirmative consent to automatic renewal at the stated price
    and interval.</p>

  <h3>4.3 Refunds</h3>

  <p>Refund requests are handled by Apple or Google in accordance with their respective refund policies. We do not
    directly process refunds.</p>

  <hr>

  <h2>5. Limitation of Liability</h2>

  <p>TO THE MAXIMUM EXTENT PERMITTED BY CALIFORNIA LAW, IN NO EVENT SHALL THE COMPANY, ITS OFFICERS, DIRECTORS,
    EMPLOYEES, AGENTS, OR AFFILIATES BE LIABLE FOR ANY INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL, OR PUNITIVE
    DAMAGES, INCLUDING WITHOUT LIMITATION LOSS OF PROFITS, DATA, USE, GOODWILL, OR OTHER
    INTANGIBLE LOSSES, RESULTING FROM:</p>

  <ul>
    <li>YOUR USE OF OR INABILITY TO USE THE APP;</li>
    <li>ANY INACCURACY, ERROR, OR OMISSION IN ANY DATA OR INFORMATION PROVIDED BY THE APP;</li>
    <li>ANY DECISION MADE OR ACTION TAKEN BY YOU IN RELIANCE ON INFORMATION PROVIDED BY THE APP;</li>
    <li>ANY UNAUTHORIZED ACCESS TO OR ALTERATION OF YOUR DATA;</li>
    <li>ANY OTHER MATTER RELATING TO THE APP.</li>
  </ul>

  <p>TO THE MAXIMUM EXTENT PERMITTED BY LAW, OUR TOTAL LIABILITY FOR ALL CLAIMS ARISING FROM OR RELATED TO THE APP SHALL
    NOT EXCEED THE AMOUNT YOU HAVE PAID TO US IN SUBSCRIPTION FEES DURING THE TWELVE (12) MONTHS IMMEDIATELY PRECEDING
    THE EVENT GIVING RISE TO THE CLAIM.</p>

  <p>Nothing in these Terms excludes or limits liability for gross negligence, fraud, or any liability that cannot be
    excluded or limited under California law.</p>

  <hr>

  <h2>6. Indemnification</h2>

  <p>You agree to indemnify, defend, and hold harmless the Company and its officers, directors, employees, and agents
    from and against any and all claims, damages, losses, liabilities, costs, and expenses (including reasonable
    attorneys' fees) arising from or related to: (a) your use of the App; (b) your
    violation of these Terms; (c) your violation of any rights of a third party; or (d) any decision or action you take
    based on information obtained through the App.</p>

  <hr>

  <h2>7. Intellectual Property</h2>

  <p>All content, features, functionality, software, data compilations, derived datasets, visualizations, maps, and
    design elements of the App are the property of the Company or its licensors and are protected by copyright,
    trademark, and other intellectual property laws. Underlying government data is in the
    public domain; however, our specific compilation, combination, presentation, and derived inferences from that data
    are proprietary.</p>

  <hr>

  <h2>8. Privacy</h2>

  <h3>8.1 Information We Collect</h3>

  <p>The App collects information when you download and use it. This information may include:</p>

  <ul>
    <li>Device location data (GPS coordinates)</li>
    <li>Your device's Internet Protocol address (IP address)</li>
    <li>The pages and features of the App that you visit, the time and date of your visit, and the time spent on those
      pages</li>
    <li>Property search history and addresses queried</li>
    <li>Device identifiers and the operating system on your mobile device</li>
    <li>App usage analytics</li>
    <li>Subscription and purchase information via RevenueCat</li>
  </ul>

  <h3>8.2 How We Use Information</h3>

  <p>We use collected information to:</p>

  <ul>
    <li>Provide and improve the App's services, including location-based property lookups and personalized content</li>
    <li>Process property data requests</li>
    <li>Maintain search history</li>
    <li>Manage subscriptions</li>
    <li>Analyze user behavior, identify trends, and improve the overall performance and functionality of the App</li>
    <li>Contact you from time to time to provide important information, required notices, and marketing promotions</li>
  </ul>

  <h3>8.3 Third-Party Services and Data Sharing</h3>

  <p>We use the following third-party services that may receive your data: Mapbox (mapping and geocoding), RevenueCat
    (subscription management), Google Play Services, and Apple App Store and Google Play Store (distribution and
    payments). Each of these services has its own privacy policy governing the
    handling of your data.</p>

  <p>Periodically, aggregated and anonymized data may be transmitted to external services to aid in improving the App
    and our offerings. We may also disclose your information:</p>

  <ul>
    <li>As required by law, such as to comply with a subpoena or similar legal process;</li>
    <li>When we believe in good faith that disclosure is necessary to protect our rights, protect your safety or the
      safety of others, investigate fraud, or respond to a government request;</li>
    <li>To trusted service providers who work on our behalf, do not have an independent use of the information we
      disclose to them, and have agreed to adhere to the rules set forth in this privacy statement.</li>
  </ul>

  <h3>8.4 California Privacy Rights (CCPA/CPRA)</h3>

  <p>If you are a California resident, you have the right to: (a) know what personal information we collect about you;
    (b) request deletion of your personal information; (c) opt out of the sale or sharing of your personal information.
    We do not sell your personal information. To exercise your rights, contact
    us at the email address provided below.</p>

  <h3>8.5 Data Retention and Deletion</h3>

  <p>Search history is stored locally on your device and can be deleted by you at any time through the App's History
    screen. We retain server-side user-provided data for as long as you use the App and for a reasonable time
    thereafter. If you would like us to delete user-provided data, please contact us at
    support@focusreintel.com and we will respond in a reasonable time.</p>

  <h3>8.6 Opt-Out</h3>

  <p>You can stop all collection of information by the App by uninstalling it. You may use the standard uninstall
    processes available on your mobile device or via the mobile application marketplace.</p>

  <h3>8.7 Children's Privacy</h3>

  <p>The App does not address anyone under the age of 13. We do not knowingly collect personally identifiable
    information from children under 13 years of age. If we discover that a child under 13 has provided personal
    information, we will immediately delete it from our servers. If you are a parent or
    guardian and you are aware that your child has provided us with personal information, please contact us at
    support@focusreintel.com so that we can take the necessary actions.</p>

  <h3>8.8 Security</h3>

  <p>We are concerned about safeguarding the confidentiality of your information. We provide physical, electronic, and
    procedural safeguards to protect information we process and maintain.</p>

  <h3>8.9 Do Not Track</h3>

  <p>The App does not currently respond to Do Not Track signals, as required to be disclosed under California Online
    Privacy Protection Act (CalOPPA).</p>

  <hr>

  <h2>9. Termination</h2>

  <p>We reserve the right to terminate or suspend your access to the App at any time, without prior notice or liability,
    for any reason, including breach of these Terms.</p>

  <hr>

  <h2>10. Changes to Terms</h2>

  <p>We may modify these Terms at any time. Material changes will be communicated through the App. Your continued use of
    the App after changes are posted constitutes acceptance of the modified Terms.</p>

  <hr>

  <h2>11. Governing Law and Dispute Resolution</h2>

  <p>These Terms are governed by and construed in accordance with the laws of the State of California, without regard to
    conflict of law principles. Any dispute arising from or relating to these Terms or the App shall be resolved in the
    state or federal courts located in California, and you consent to the
    personal jurisdiction of such courts.</p>

  <hr>

  <h2>12. Severability</h2>

  <p>If any provision of these Terms is found to be unenforceable or invalid by a court of competent jurisdiction, that
    provision shall be limited or eliminated to the minimum extent necessary, and the remaining provisions shall remain
    in full force and effect.</p>

  <hr>

  <h2>13. Entire Agreement</h2>

  <p>These Terms, together with Apple's standard Licensed Application End User License Agreement (which also applies to
    your use of the App), constitute the entire agreement between you and the Company regarding the App.</p>

  <hr>

  <h2>14. Contact</h2>

  <p>For questions about these Terms, contact us at:</p>

  <p><strong>Email:</strong> support@focusreintel.com</p>

  <hr>

  <p style="text-align: center;">
    <em>By using California Places, you acknowledge that you have read, understood, and agree to be bound by these Terms of Service.</em>
  </p>

</div>`}
          ></Script>
        </div>
      </div>
      <Footer rootClassName="footerroot-class-name"></Footer>
    </div>
  )
}

export default TermsOfService
